
import { eventHandler, translations } from "@/mixins";
import { Table, TableColumn, Button } from "element-ui";
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { Applications } from "@/services/SOLO";
import { mapGetters } from "vuex";
import { TPaginationMetaObj } from "@/models/Pagination";
interface Item {
  key: string;
  language: string;
  value: string;
  [key: string]: any;
}

interface FormattedItem {
  editable: boolean;
  id: number;
  key: string;
  [language: string]: any;
}
@Component({
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      getLocale: 'app/getLocale',
    }),
  },
  mixins: [eventHandler, translations],
})
export default class Content extends Vue {
  public translate!: Function;
  loading: boolean = false;
  color: string = "white";
  list: any;
  search: string = "";
  updatable: any;
  getLocale!: any;
  paginationMeta: TPaginationMetaObj = {
    per_page: 100,
    prev_cursor: null,
    next_cursor: null,
  };

  mounted() {
    this.getTranslations(null);
  }

  isArabic(): boolean {
    return this.getCurrentLocale(this.getLocale) === 'ar-sa'
  }

  getCurrentLocale(currentLocale: string): string {
    const locale: any = {
      en_US: "en-us",
      ar_SA: "ar-sa",
      fr_FR: "fr-fr",
    };
    return locale[currentLocale];
  }

  pageChange(cursor: string | null) {
    this.getTranslations(cursor);
  }

  async getTranslations(cursor: string | null) {
    this.loading = true;
    const { data }: any = await Applications.getTranslations(
      this.$route.params.id,
      this.search,
      cursor
    );
    this.paginationMeta = data?.meta?.pagination;
    const formatList = data.data.map((item: any, idx: number) => ({
      ...item,
      id: idx,
      editable: false
    }))
    this.list = formatList;
    this.loading = false;
  }

  toggleRow(row: any, data: boolean) {
    this.updatable = {}

    this.list.forEach((item: any) => {
      if (item.id == row.id) {
        // collect updated row
        if (!data) {
          // this.updatable.push(item.attributes)
          this.updatable["translations"] = [
            {
              language: "en-us",
              key: item.key,
              value: item["value-en"],
            },
            {
              language: "ar-sa",
              key: item.key,
              value: item["value-ar"],
            },
          ];
        }
        item.editable = data;
      }
    });

    if (Object.keys(this.updatable).length) {
      /* @ts-ignore */
      this.updateTranslation();
    }
  }

  async updateTranslation() {
    try {
      await Applications.updateTranslation(
        this.$route.params.id,
        this.updatable
      );
    } catch (error) {
      console.error("Error in updating translation", error);
    }
  }
}
